import { type AdminSearchMyExamRoomRequestInfosQuery } from '@exam-center/graphql';

type ExamRoomRequestInfo =
  AdminSearchMyExamRoomRequestInfosQuery['ecAdminSearchMyExamRoomRequestInfos']['examRoomRequestInfos'][number];

export function mapExamLocationRequestData(data: ExamRoomRequestInfo[]) {
  return data.map((item) => ({
    id: item.id,
    refCode: item.taskCode ?? '-',
    buildingName:
      item.examLocationRequestInfo.building?.nameTh ??
      item.examLocationRequestInfo.buildingName ??
      '-',
    locationName: item.examLocationRequestInfo.nameTh ?? '-',
    province: item.examLocationRequestInfo.province.nameTh,
    floor: item.floor,
    roomName: item.name,
    roomNumber: item.roomNumber ?? '-',
    examCenter: item.examCenterCode,
    requestedAt: item.requestedAt,
    step: item.step,
    status: 'in-review',
  }));
}
